import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

const Process3DIcon = ({ type }: { type: string }): React.ReactElement => {
  const icons: Record<string, React.ReactElement> = {
    'ri-search-eye-line': (
      <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs><linearGradient id="p1" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#7DBFF5"/><stop offset="100%" stopColor="#2478C8"/></linearGradient><filter id="pg1"><feGaussianBlur stdDeviation="2.5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>
        <circle cx="34" cy="34" r="20" fill="none" stroke="url(#p1)" strokeWidth="2.5" opacity="0.9" filter="url(#pg1)"/>
        <circle cx="34" cy="34" r="20" fill="#4A9EE8" opacity="0.07"/>
        <circle cx="34" cy="34" r="10" fill="none" stroke="#7DBFF5" strokeWidth="1.5" opacity="0.6"/>
        <circle cx="34" cy="34" r="4" fill="#7DBFF5" opacity="0.9" filter="url(#pg1)"/>
        <line x1="48" y1="48" x2="64" y2="64" stroke="url(#p1)" strokeWidth="3" strokeLinecap="round" filter="url(#pg1)"/>
        <circle cx="64" cy="64" r="3" fill="#7DBFF5" opacity="0.9"/>
        <circle cx="34" cy="14" r="2.5" fill="#4A9EE8" opacity="0.7"/>
        <circle cx="54" cy="34" r="2.5" fill="#4A9EE8" opacity="0.7"/>
      </svg>
    ),
    'ri-file-search-line': (
      <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs><linearGradient id="p2" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#7DBFF5"/><stop offset="100%" stopColor="#2478C8"/></linearGradient><filter id="pg2"><feGaussianBlur stdDeviation="2.5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>
        <rect x="16" y="10" width="38" height="50" rx="5" fill="none" stroke="url(#p2)" strokeWidth="2" opacity="0.9" filter="url(#pg2)"/>
        <rect x="16" y="10" width="38" height="50" rx="5" fill="#4A9EE8" opacity="0.07"/>
        <line x1="24" y1="26" x2="46" y2="26" stroke="#4A9EE8" strokeWidth="1.5" opacity="0.6"/>
        <line x1="24" y1="34" x2="46" y2="34" stroke="#4A9EE8" strokeWidth="1.5" opacity="0.6"/>
        <line x1="24" y1="42" x2="36" y2="42" stroke="#4A9EE8" strokeWidth="1.5" opacity="0.5"/>
        <circle cx="52" cy="56" r="10" fill="none" stroke="#7DBFF5" strokeWidth="2" opacity="0.8" filter="url(#pg2)"/>
        <circle cx="52" cy="56" r="4" fill="#7DBFF5" opacity="0.85"/>
        <line x1="59" y1="63" x2="66" y2="70" stroke="#4A9EE8" strokeWidth="2.5" strokeLinecap="round"/>
        <circle cx="16" cy="10" r="2.5" fill="#7DBFF5" opacity="0.8"/>
        <circle cx="54" cy="10" r="2.5" fill="#4A9EE8" opacity="0.7"/>
      </svg>
    ),
    'ri-team-line': (
      <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs><linearGradient id="p3" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#7DBFF5"/><stop offset="100%" stopColor="#2478C8"/></linearGradient><filter id="pg3"><feGaussianBlur stdDeviation="2.5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>
        <circle cx="40" cy="24" r="10" fill="none" stroke="url(#p3)" strokeWidth="2" opacity="0.9" filter="url(#pg3)"/>
        <circle cx="40" cy="24" r="5" fill="#7DBFF5" opacity="0.8"/>
        <path d="M20 60 Q20 44 40 44 Q60 44 60 60" fill="none" stroke="url(#p3)" strokeWidth="2" opacity="0.8" filter="url(#pg3)"/>
        <circle cx="18" cy="32" r="7" fill="none" stroke="#4A9EE8" strokeWidth="1.5" opacity="0.6"/>
        <path d="M6 58 Q6 46 18 46 Q26 46 28 52" fill="none" stroke="#4A9EE8" strokeWidth="1.5" opacity="0.5"/>
        <circle cx="62" cy="32" r="7" fill="none" stroke="#4A9EE8" strokeWidth="1.5" opacity="0.6"/>
        <path d="M74 58 Q74 46 62 46 Q54 46 52 52" fill="none" stroke="#4A9EE8" strokeWidth="1.5" opacity="0.5"/>
        <circle cx="40" cy="14" r="2.5" fill="#7DBFF5" opacity="0.9" filter="url(#pg3)"/>
      </svg>
    ),
    'ri-line-chart-line': (
      <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs><linearGradient id="p4" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#7DBFF5"/><stop offset="100%" stopColor="#2478C8"/></linearGradient><filter id="pg4"><feGaussianBlur stdDeviation="2.5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>
        <polyline points="10,60 24,40 38,48 52,24 66,32" fill="none" stroke="url(#p4)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.9" filter="url(#pg4)"/>
        <line x1="10" y1="68" x2="70" y2="68" stroke="#4A9EE8" strokeWidth="1.5" opacity="0.4"/>
        <line x1="10" y1="10" x2="10" y2="68" stroke="#4A9EE8" strokeWidth="1.5" opacity="0.4"/>
        <circle cx="10" cy="60" r="3.5" fill="#7DBFF5" opacity="0.9"/>
        <circle cx="24" cy="40" r="3.5" fill="#4A9EE8" opacity="0.8"/>
        <circle cx="38" cy="48" r="3.5" fill="#4A9EE8" opacity="0.8"/>
        <circle cx="52" cy="24" r="4" fill="#7DBFF5" opacity="0.95" filter="url(#pg4)"/>
        <circle cx="66" cy="32" r="3.5" fill="#4A9EE8" opacity="0.8"/>
      </svg>
    ),
  };
  return icons[type] || icons['ri-search-eye-line'];
};

const Value3DIcon = ({ type }: { type: string }): React.ReactElement => {
  const icons: Record<string, React.ReactElement> = {
    'ri-shield-check-line': (
      <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs><linearGradient id="v1" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#7DBFF5"/><stop offset="100%" stopColor="#2478C8"/></linearGradient><filter id="vg1"><feGaussianBlur stdDeviation="2.5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>
        <path d="M40 8 L64 19 L64 43 Q64 60 40 72 Q16 60 16 43 L16 19 Z" fill="#4A9EE8" opacity="0.08"/>
        <path d="M40 8 L64 19 L64 43 Q64 60 40 72 Q16 60 16 43 L16 19 Z" fill="none" stroke="url(#v1)" strokeWidth="2" opacity="0.9" filter="url(#vg1)"/>
        <polyline points="29,41 37,49 53,31" fill="none" stroke="#7DBFF5" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" filter="url(#vg1)" opacity="0.95"/>
        <circle cx="40" cy="8" r="3.5" fill="#7DBFF5" opacity="0.9"/>
      </svg>
    ),
    'ri-time-line': (
      <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs><linearGradient id="v2" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#7DBFF5"/><stop offset="100%" stopColor="#2478C8"/></linearGradient><filter id="vg2"><feGaussianBlur stdDeviation="2.5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>
        <circle cx="40" cy="40" r="26" fill="none" stroke="url(#v2)" strokeWidth="2" opacity="0.9" filter="url(#vg2)"/>
        <circle cx="40" cy="40" r="26" fill="#4A9EE8" opacity="0.06"/>
        <path d="M40 18 L40 40 L54 54" fill="none" stroke="#7DBFF5" strokeWidth="2.5" strokeLinecap="round" filter="url(#vg2)" opacity="0.9"/>
        <circle cx="40" cy="40" r="4" fill="#7DBFF5" opacity="0.95" filter="url(#vg2)"/>
        <circle cx="40" cy="14" r="3" fill="#4A9EE8" opacity="0.8"/>
        <circle cx="66" cy="40" r="3" fill="#4A9EE8" opacity="0.8"/>
        <circle cx="40" cy="66" r="3" fill="#4A9EE8" opacity="0.8"/>
        <circle cx="14" cy="40" r="3" fill="#4A9EE8" opacity="0.8"/>
      </svg>
    ),
    'ri-award-line': (
      <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs><linearGradient id="v3" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#7DBFF5"/><stop offset="100%" stopColor="#2478C8"/></linearGradient><filter id="vg3"><feGaussianBlur stdDeviation="2.5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>
        <circle cx="40" cy="30" r="20" fill="none" stroke="url(#v3)" strokeWidth="2" opacity="0.9" filter="url(#vg3)"/>
        <circle cx="40" cy="30" r="20" fill="#4A9EE8" opacity="0.07"/>
        <polygon points="40,18 43,26 52,26 45,31 48,40 40,35 32,40 35,31 28,26 37,26" fill="#7DBFF5" opacity="0.85" filter="url(#vg3)"/>
        <line x1="32" y1="50" x2="26" y2="68" stroke="url(#v3)" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
        <line x1="48" y1="50" x2="54" y2="68" stroke="url(#v3)" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
        <circle cx="26" cy="68" r="3" fill="#4A9EE8" opacity="0.7"/>
        <circle cx="54" cy="68" r="3" fill="#4A9EE8" opacity="0.7"/>
      </svg>
    ),
    'ri-lightbulb-line': (
      <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs><linearGradient id="v4" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#7DBFF5"/><stop offset="100%" stopColor="#2478C8"/></linearGradient><filter id="vg4"><feGaussianBlur stdDeviation="2.5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>
        <path d="M28 44 Q20 36 20 28 Q20 12 40 12 Q60 12 60 28 Q60 36 52 44 L52 54 L28 54 Z" fill="none" stroke="url(#v4)" strokeWidth="2" opacity="0.9" filter="url(#vg4)"/>
        <path d="M28 44 Q20 36 20 28 Q20 12 40 12 Q60 12 60 28 Q60 36 52 44 L52 54 L28 54 Z" fill="#4A9EE8" opacity="0.08"/>
        <line x1="32" y1="58" x2="48" y2="58" stroke="#4A9EE8" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
        <line x1="34" y1="63" x2="46" y2="63" stroke="#4A9EE8" strokeWidth="2" strokeLinecap="round" opacity="0.5"/>
        <circle cx="40" cy="30" r="6" fill="#7DBFF5" opacity="0.85" filter="url(#vg4)"/>
        <circle cx="40" cy="12" r="3" fill="#7DBFF5" opacity="0.9" filter="url(#vg4)"/>
      </svg>
    ),
    'ri-settings-3-line': (
      <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs><linearGradient id="v5" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#7DBFF5"/><stop offset="100%" stopColor="#2478C8"/></linearGradient><filter id="vg5"><feGaussianBlur stdDeviation="2.5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>
        <circle cx="40" cy="40" r="12" fill="none" stroke="url(#v5)" strokeWidth="2" opacity="0.9" filter="url(#vg5)"/>
        <circle cx="40" cy="40" r="6" fill="#7DBFF5" opacity="0.85"/>
        <line x1="40" y1="10" x2="40" y2="24" stroke="#4A9EE8" strokeWidth="2" opacity="0.8"/>
        <line x1="40" y1="56" x2="40" y2="70" stroke="#4A9EE8" strokeWidth="2" opacity="0.8"/>
        <line x1="10" y1="40" x2="24" y2="40" stroke="#4A9EE8" strokeWidth="2" opacity="0.8"/>
        <line x1="56" y1="40" x2="70" y2="40" stroke="#4A9EE8" strokeWidth="2" opacity="0.8"/>
        <line x1="18" y1="18" x2="28" y2="28" stroke="#4A9EE8" strokeWidth="1.5" opacity="0.6"/>
        <line x1="52" y1="52" x2="62" y2="62" stroke="#4A9EE8" strokeWidth="1.5" opacity="0.6"/>
        <line x1="62" y1="18" x2="52" y2="28" stroke="#4A9EE8" strokeWidth="1.5" opacity="0.6"/>
        <line x1="28" y1="52" x2="18" y2="62" stroke="#4A9EE8" strokeWidth="1.5" opacity="0.6"/>
        <circle cx="40" cy="10" r="3" fill="#7DBFF5" opacity="0.9" filter="url(#vg5)"/>
        <circle cx="70" cy="40" r="3" fill="#4A9EE8" opacity="0.8"/>
      </svg>
    ),
  };
  return icons[type] || icons['ri-shield-check-line'];
};

export default function AboutPage() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const location = useLocation();

  useEffect(() => { window.scrollTo(0, 0); }, [location]);

  const processSteps = [
    { step: '01', titleKey: 'aboutPage.process.step1.title', descKey: 'aboutPage.process.step1.desc', icon: 'ri-search-eye-line' },
    { step: '02', titleKey: 'aboutPage.process.step2.title', descKey: 'aboutPage.process.step2.desc', icon: 'ri-file-search-line' },
    { step: '03', titleKey: 'aboutPage.process.step3.title', descKey: 'aboutPage.process.step3.desc', icon: 'ri-team-line' },
    { step: '04', titleKey: 'aboutPage.process.step4.title', descKey: 'aboutPage.process.step4.desc', icon: 'ri-line-chart-line' },
  ];

  const values = [
    { titleKey: 'aboutPage.values.integrity', descKey: 'aboutPage.values.integrityDesc', icon: 'ri-shield-check-line' },
    { titleKey: 'aboutPage.values.longTerm', descKey: 'aboutPage.values.longTermDesc', icon: 'ri-time-line' },
    { titleKey: 'aboutPage.values.excellence', descKey: 'aboutPage.values.excellenceDesc', icon: 'ri-award-line' },
    { titleKey: 'aboutPage.values.innovation', descKey: 'aboutPage.values.innovationDesc', icon: 'ri-lightbulb-line' },
    { titleKey: 'aboutPage.values.collaboration', descKey: 'aboutPage.values.collaborationDesc', icon: 'ri-settings-3-line' },
  ];

  return (
    <div className={`min-h-screen ${isRTL ? 'rtl' : 'ltr'}`} dir={isRTL ? 'rtl' : 'ltr'} style={{ backgroundColor: '#ffffff' }}>
      <Navbar />

      {/* Hero */}
      <section className="relative pt-28 sm:pt-40 pb-16 sm:pb-24 overflow-hidden">
        <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, #0d2137 0%, #0d2137 50%, #0d2137 100%)' }} />
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full blur-3xl" style={{ backgroundColor: 'rgba(74,158,232,0.08)' }} />
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 relative">
          <div className="flex items-center gap-2 text-sm mb-8">
            <Link to="/" style={{ color: 'rgba(255,255,255,0.4)' }}>{t('aboutPage.breadcrumb.home')}</Link>
            <i className={isRTL ? 'ri-arrow-left-s-line' : 'ri-arrow-right-s-line'} style={{ color: 'rgba(255,255,255,0.3)' }} />
            <span style={{ color: '#4A9EE8' }}>{t('aboutPage.breadcrumb.about')}</span>
          </div>
          <div className="flex items-center gap-3 mb-6">
            <div style={{ width: '3rem', height: '1px', backgroundColor: '#4A9EE8' }} />
            <span style={{ color: '#4A9EE8', fontSize: '0.75rem', fontWeight: '600', letterSpacing: '0.2em', textTransform: 'uppercase' }}>{t('aboutPage.hero.label')}</span>
          </div>
          <h1 className="font-serif leading-tight mb-6" style={{ fontSize: 'clamp(2rem, 8vw, 4rem)', color: '#ffffff' }}>
            {t('aboutPage.hero.title1')} <span style={{ color: '#4A9EE8' }}>{t('aboutPage.hero.title2')}</span>
          </h1>
          <p style={{ fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', color: 'rgba(255,255,255,0.55)', maxWidth: '40rem', lineHeight: '1.8' }}>{t('aboutPage.hero.description')}</p>
        </div>
      </section>

      {/* Story */}
      <section style={{ backgroundColor: '#ffffff', paddingTop: 'clamp(3rem, 8vw, 6rem)', paddingBottom: 'clamp(3rem, 8vw, 6rem)' }}>
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" style={{ marginBottom: '6rem' }}>
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img src="/about2.png" alt="Advanced Energy Technology"
                  style={{ width: '100%', height: 'clamp(260px, 50vw, 500px)', objectFit: 'cover' }}
                  onError={(e) => { (e.target as HTMLImageElement).src = 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=800&q=80'; }}/>
              </div>
              <div className="absolute rounded-2xl text-center shadow-xl" style={{ bottom: '-1.5rem', right: '1.5rem', backgroundColor: '#4A9EE8', padding: '1rem 1.5rem' }}>
                <div className="font-serif font-bold" style={{ fontSize: '2rem', color: '#ffffff' }}>2025</div>
                <div style={{ fontSize: '0.7rem', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.8)', marginTop: '0.25rem' }}>{t('aboutPage.established')}</div>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <div style={{ width: '3rem', height: '1px', backgroundColor: '#4A9EE8' }} />
                <span style={{ color: '#4A9EE8', fontSize: '0.75rem', fontWeight: '600', letterSpacing: '0.2em', textTransform: 'uppercase' }}>{t('aboutPage.story.label')}</span>
              </div>
              <h2 className="font-serif" style={{ fontSize: 'clamp(1.8rem, 5vw, 2.8rem)', lineHeight: 1.2, color: '#0d2137' }}>
                {t('aboutPage.story.heading1')} <span style={{ color: '#4A9EE8' }}>{t('aboutPage.story.heading2')}</span>
              </h2>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                <p style={{ color: '#4a5568', fontSize: 'clamp(0.95rem, 2vw, 1.1rem)', lineHeight: '1.8' }}>{t('aboutPage.story.p1')}</p>
                <p style={{ color: '#4a5568', fontSize: 'clamp(0.95rem, 2vw, 1.1rem)', lineHeight: '1.8' }}>{t('aboutPage.story.p2')}</p>
                <p style={{ color: '#4a5568', fontSize: 'clamp(0.95rem, 2vw, 1.1rem)', lineHeight: '1.8' }}>{t('aboutPage.story.p3')}</p>
              </div>
            </div>
          </div>

          {/* CEO Quote */}
          <div className="rounded-3xl overflow-hidden relative mb-12 sm:mb-24" style={{ background: 'linear-gradient(135deg, #0d2137 0%, #0d2137 100%)', padding: 'clamp(1.5rem, 5vw, 4rem)' }}>
            <div className="absolute top-0 right-0 w-80 h-80 rounded-full blur-3xl" style={{ backgroundColor: 'rgba(74,158,232,0.08)' }} />
            <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
              <div className="lg:col-span-4 text-center">
                <div className="w-36 h-36 md:w-48 md:h-48 mx-auto rounded-full overflow-hidden border-4 border-gold/30 bg-white">
  <img
    src="/ceophoto.png"
    alt="CEO"
    className="w-full h-full object-contain object-center scale-125"
  />
</div>
                <div style={{ fontWeight: 600, fontSize: 'clamp(1rem, 3vw, 1.2rem)', color: '#ffffff' }}>{t('about.mhbm')}</div>

                <div style={{ fontWeight: 600, fontSize: 'clamp(1rem, 3vw, 1.2rem)', color: '#ffffff' }}>{t('about.ceoName')}</div>
                <div style={{ fontSize: '0.875rem', color: '#4A9EE8' }}>{t('about.ceoTitle')}</div>
              </div>
              <div className="lg:col-span-8" style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                <i className="ri-double-quotes-l" style={{ fontSize: 'clamp(2rem, 6vw, 4rem)', color: 'rgba(74,158,232,0.25)' }} />
                <p style={{ fontSize: 'clamp(1rem, 3vw, 1.5rem)', color: 'rgba(255,255,255,0.85)', lineHeight: '1.7', fontWeight: 300 }}>{t('about.ceoQuote1')}</p>
                <p style={{ fontSize: 'clamp(1rem, 3vw, 1.5rem)', color: 'rgba(255,255,255,0.85)', lineHeight: '1.7', fontWeight: 300 }}>{t('about.ceoQuote2')}</p>
              </div>
            </div>
          </div>

          {/* Process */}
          <div style={{ marginBottom: '6rem' }}>
            <div className="text-center" style={{ marginBottom: '4rem' }}>
              <div className="flex items-center justify-center gap-3 mb-6">
                <div style={{ width: '3rem', height: '1px', backgroundColor: '#4A9EE8' }} />
                <span style={{ color: '#4A9EE8', fontSize: '0.75rem', fontWeight: '600', letterSpacing: '0.2em', textTransform: 'uppercase' }}>{t('aboutPage.process.label')}</span>
                <div style={{ width: '3rem', height: '1px', backgroundColor: '#4A9EE8' }} />
              </div>
              <h2 className="font-serif" style={{ fontSize: 'clamp(1.8rem, 5vw, 2.5rem)', color: '#0d2137' }}>
                {t('aboutPage.process.title1')} <span style={{ color: '#4A9EE8' }}>{t('aboutPage.process.title2')}</span>
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {processSteps.map((item, index) => (
                <div key={index} className="group relative rounded-2xl p-6 sm:p-10 pt-10 sm:pt-14 transition-all duration-500 hover:shadow-2xl overflow-hidden" style={{
                  backgroundColor: '#e8f3fd',
                  border: '1.5px solid rgba(74,158,232,0.5)',
                  boxShadow: '0 0 16px rgba(74,158,232,0.2), 0 0 40px rgba(74,158,232,0.07), inset 0 0 16px rgba(74,158,232,0.04)',
                }}>
                  <div className="absolute top-0 left-0 right-0 h-1 w-0 group-hover:w-full transition-all duration-700" style={{ backgroundColor: '#185FA5' }} />
                  <div className="w-16 h-16 sm:w-24 sm:h-24 mb-6">
                    <Process3DIcon type={item.icon} />
                  </div>
                  <h3 style={{ fontSize: 'clamp(1.1rem, 3vw, 1.6rem)', fontWeight: 700, marginBottom: '0.75rem', color: '#0d2137' }}>{t(item.titleKey)}</h3>
                  <p style={{ fontSize: 'clamp(0.95rem, 2vw, 1.2rem)', lineHeight: '1.8', color: '#374151' }}>{t(item.descKey)}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Values */}
          <div>
            <div className="text-center" style={{ marginBottom: '4rem' }}>
              <div className="flex items-center justify-center gap-3 mb-6">
                <div style={{ width: '3rem', height: '1px', backgroundColor: '#4A9EE8' }} />
                <span style={{ color: '#4A9EE8', fontSize: '0.75rem', fontWeight: '600', letterSpacing: '0.2em', textTransform: 'uppercase' }}>{t('aboutPage.values.label')}</span>
                <div style={{ width: '3rem', height: '1px', backgroundColor: '#4A9EE8' }} />
              </div>
              <h2 className="font-serif" style={{ fontSize: 'clamp(1.8rem, 5vw, 2.5rem)', color: '#0d2137' }}>
                {t('aboutPage.values.title1')} <span style={{ color: '#4A9EE8' }}>{t('aboutPage.values.title2')}</span>
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {values.map((value, index) => (
                <div key={index} className={`group relative rounded-2xl p-6 sm:p-10 pt-10 sm:pt-14 transition-all duration-500 hover:shadow-2xl overflow-hidden ${index === 4 ? 'lg:col-start-2' : ''}`} style={{
                  backgroundColor: '#0d2137',
                  border: '1.5px solid rgba(74,158,232,0.5)',
                  boxShadow: '0 0 16px rgba(74,158,232,0.2), 0 0 40px rgba(74,158,232,0.07), inset 0 0 16px rgba(74,158,232,0.04)',
                }}>
                  <div className="absolute top-0 left-0 right-0 h-1 w-0 group-hover:w-full transition-all duration-700" style={{ backgroundColor: '#4A9EE8' }} />
                  <div className="w-16 h-16 sm:w-24 sm:h-24 mb-6">
                    <Value3DIcon type={value.icon} />
                  </div>
                  <h3 style={{ fontSize: 'clamp(1.1rem, 3vw, 1.6rem)', fontWeight: 700, marginBottom: '0.75rem', color: '#ffffff' }}>{t(value.titleKey)}</h3>
                  <p style={{ fontSize: 'clamp(0.95rem, 2vw, 1.2rem)', lineHeight: '1.8', color: 'rgba(255,255,255,0.75)' }}>{t(value.descKey)}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
